import { CounterpartyDirectionOverride } from "../../helpers/counterparties";
import {
    Counterparty,
    CounterpartySource,
    FederalTaxClassification,
} from "../../types/counterparty";

export class CounterpartyDto {
    static deserialize(dto: CounterpartyDto): Omit<Counterparty, "sourceId"> {
        return dto;
    }

    id: string;
    name: string;
    companyName: string | null;
    workspaceId: string | null;
    updatedByUserId: number | null;
    source: CounterpartySource | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    email: string | null;
    cc: string | null;
    bcc: string | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    phoneNumber: string | null;
    website: string | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    title: string | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    firstName: string | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    middleName: string | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    lastName: string | null;
    /** @deprecated Legacy contact scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_contact`. */
    suffix: string | null;
    /** @deprecated Legacy address scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_address`. */
    street: string | null;
    /** @deprecated Legacy address scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_address`. */
    street2: string | null;
    /** @deprecated Legacy address scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_address`. */
    city: string | null;
    /** @deprecated Legacy address scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_address`. */
    postalCode: string | null;
    /** @deprecated Legacy address scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_address`. */
    state: string | null;
    /** @deprecated Legacy address scalar — write via `CounterpartyDetailsInternalService`; see `counterparty_address`. */
    country: string | null;
    shouldBeNormalized: boolean;
    directionOverride: CounterpartyDirectionOverride | null;
    isEligible1099: boolean | null;
    federalTaxClassification: FederalTaxClassification | null;
    note: string | null;
    disabledAt: Date | null;

    constructor(counterparty: Counterparty) {
        this.id = counterparty.id;
        this.name = counterparty.name;
        this.companyName = counterparty.companyName;
        this.workspaceId = counterparty.workspaceId;
        this.updatedByUserId = counterparty.updatedByUserId;
        this.source = counterparty.source;
        this.email = counterparty.email;
        this.cc = counterparty.cc;
        this.bcc = counterparty.bcc;
        this.phoneNumber = counterparty.phoneNumber;
        this.website = counterparty.website;
        this.title = counterparty.title;
        this.firstName = counterparty.firstName;
        this.middleName = counterparty.middleName;
        this.lastName = counterparty.lastName;
        this.suffix = counterparty.suffix;
        this.street = counterparty.street;
        this.street2 = counterparty.street2;
        this.city = counterparty.city;
        this.postalCode = counterparty.postalCode;
        this.state = counterparty.state;
        this.country = counterparty.country;
        this.shouldBeNormalized = counterparty.shouldBeNormalized;
        this.directionOverride = counterparty.directionOverride;
        this.isEligible1099 = counterparty.isEligible1099;
        this.federalTaxClassification = counterparty.federalTaxClassification;
        this.note = counterparty.note;
        this.disabledAt = counterparty.disabledAt;
    }
}
